import React from 'react'
import Buttons from '../../components/Buttons'
export default () => (
  <Buttons />
)